import { DescriptionList, TruncatedText } from '@circlefin/components'
import { MaybeNull } from '@shared/components/common'

import type { Maybe } from '@shared/graphql'

const { Label, Description } = DescriptionList

export interface FundingSourceProps {
  /**
   * Label for the funding source.
   */
  label: string
  /**
   * Name of the funding source.
   */
  name?: Maybe<string>
  /**
   * Description of the funding source.
   */
  description?: Maybe<string>
  /**
   * Indicates if the description should be truncated.
   */
  truncatedDescription?: boolean
}

export const FundingSource: React.FC<FundingSourceProps> = ({
  label,
  name,
  description,
  truncatedDescription = false,
}) => {
  return (
    <>
      <Label>{label}</Label>
      <Description>
        <MaybeNull>{name}</MaybeNull>
        &nbsp;
        {truncatedDescription && description ? (
          <TruncatedText>{description}</TruncatedText>
        ) : (
          <p>{description}</p>
        )}
      </Description>
    </>
  )
}
